<div class="tw-flex tw-flex-col tw-gap-6">
  <div class="tw-flex tw-items-center tw-gap-2 md:tw-gap-8 tw-flex-wrap">
    <div class="tw-text-sm tw-font-semibold tw-text-gray-700 tw-font-inter">Event occurs on</div>
    <div class="tw-flex tw-gap-4 tw-overflow-x-auto tw-flex-nowrap md:tw-flex-wrap">
      @for (d of weekDayOptions(); track d) {
        <button
          type="button"
          (click)="onToggleWeekDay(d)"
          class="tw-h-14 tw-min-w-14 tw-rounded-lg tw-border tw-text-sm tw-font-inter tw-transition-colors"
          [ngClass]="{
            'tw-border-blue-600 tw-text-blue-600 tw-bg-blue-50': selectedWeekDays().includes(d),
            'tw-border-gray-100 tw-text-gray-500 tw-bg-gray-50': !selectedWeekDays().includes(d),
          }"
        >
          {{ d }}
        </button>
      }
    </div>
  </div>

  <div class="tw-flex tw-gap-2 md:tw-gap-8 tw-flex-wrap tw-flex-col md:tw-flex-row">
    <div class="weekly-hours-editor__label-col tw-text-sm tw-font-semibold tw-text-gray-700 tw-font-inter">Opening Hours</div>
    <div class="tw-flex tw-flex-col md:tw-flex-row tw-gap-6">
      <label class="tw-inline-flex tw-items-center tw-gap-2 tw-text-sm tw-font-medium tw-font-inter" [class.tw-opacity-50]="isDisabled()">
        <input
          type="radio"
          name="openingHoursMode"
          class="tw-h-4 tw-w-4 tw-border-gray-300 tw-accent-blue-600 focus:tw-ring-blue-500"
          [disabled]="isDisabled()"
          [checked]="openingHoursMode() === 'same'"
          (change)="onOpeningHoursModeChange('same')"
        />
        Same hours every day
      </label>
      <label class="tw-inline-flex tw-items-center tw-gap-2 tw-text-sm tw-font-medium tw-font-inter" [class.tw-opacity-50]="isDisabled()">
        <input
          type="radio"
          name="openingHoursMode"
          class="tw-h-4 tw-w-4 tw-border-gray-300 tw-accent-blue-600 focus:tw-ring-blue-500"
          [disabled]="isDisabled()"
          [checked]="openingHoursMode() === 'different'"
          (change)="onOpeningHoursModeChange('different')"
        />
        Different hours
      </label>
    </div>
  </div>

  @if (!isDisabled()) {
    @if (openingHoursMode() === 'same') {
      <div class="tw-flex tw-gap-8 tw-flex-wrap">
        <div class="weekly-hours-editor__label-col tw-hidden md:tw-block"></div>
        <div class="tw-flex tw-flex-col tw-gap-1">
          <div class="tw-flex tw-flex-col md:tw-flex-row tw-gap-4">
            <div class="weekly-hours-editor__time-col">
              <app-event-time-picker
                label="Opening Time"
                labelTextSize="xs"
                [fixedHeight]="true"
                [hour]="sameHoursStartHour()"
                [minute]="sameHoursStartMinute()"
                (hourChange)="onSameHoursPatch({ startHour: $event })"
                (minuteChange)="onSameHoursPatch({ startMinute: $event })"
              />
            </div>
            <div class="weekly-hours-editor__time-col">
              <app-event-time-picker
                label="Closing Time"
                labelTextSize="xs"
                [fixedHeight]="true"
                [hour]="sameHoursEndHour()"
                [minute]="sameHoursEndMinute()"
                (hourChange)="onSameHoursPatch({ endHour: $event })"
                (minuteChange)="onSameHoursPatch({ endMinute: $event })"
              />
            </div>
          </div>
          @if (sameHoursError(); as sameHoursErr) {
            <p class="tw-text-xs tw-text-red-600 tw-font-inter" role="alert">{{ sameHoursErr }}</p>
          }
        </div>
      </div>
    } @else {
      <div class="tw-flex tw-flex-col md:tw-gap-6">
        @for (d of selectedWeekDays(); track d) {
          <div class="tw-flex tw-flex-col tw-gap-1">
            <div class="tw-flex tw-flex-col md:tw-flex-row tw-gap-3 md:tw-gap-8">
              <div class="weekly-hours-editor__label-col md:tw-mt-10 tw-text-sm tw-font-medium tw-text-gray-700 tw-font-inter">
                {{ dayWeekFullName()[d] }}
              </div>
              <div class="tw-flex tw-flex-col tw-gap-1">
                <div class="tw-flex tw-gap-3 md:tw-gap-4 tw-flex-nowrap">
                  <div class="weekly-hours-editor__time-col-responsive tw-w-full">
                    <app-event-time-picker
                      label="Opening Time"
                      labelTextSize="xs"
                      [fixedHeight]="true"
                      [hour]="perDayHours()[d].startHour"
                      [minute]="perDayHours()[d].startMinute"
                      (hourChange)="onPerDayPatch(d, { startHour: $event })"
                      (minuteChange)="onPerDayPatch(d, { startMinute: $event })"
                    />
                  </div>
                  <div class="weekly-hours-editor__time-col-responsive tw-w-full">
                    <app-event-time-picker
                      label="Closing Time"
                      labelTextSize="xs"
                      [fixedHeight]="true"
                      [hour]="perDayHours()[d].endHour"
                      [minute]="perDayHours()[d].endMinute"
                      (hourChange)="onPerDayPatch(d, { endHour: $event })"
                      (minuteChange)="onPerDayPatch(d, { endMinute: $event })"
                    />
                  </div>
                </div>
                @if (perDayErrorByDay()[d]; as dayHoursErr) {
                  <p class="tw-text-xs tw-text-red-600 tw-font-inter" role="alert">{{ dayHoursErr }}</p>
                }
              </div>
            </div>
          </div>
          @if (!$last) {
            <hr class="md:tw-hidden tw-border-gray-200 tw-my-6 tw-opacity-100" />
          }
        }
      </div>
    }
  }
</div>

